import React from 'react';
import HeaderBar from './Header'

import SideBar from './SideBar'

import { Layout } from 'antd';

import ReactAlert from '../sharedComponets/ReactAlert'
import './style.scss';


const { Content, Sider } = Layout;

class PreviewComponent extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            collapsed: true,
            domainColors: {}
        }
        this.toggleSideBar = this.toggleSideBar.bind(this)
    }

    toggleSideBar() {
        this.setState({
            collapsed: !this.state.collapsed
        })
    }



    render() {

        return (
            <div className={this.state.collapsed ? "main-preview " : "collapsed main-preview"}>
                <ReactAlert />
                <aside className="main-preview__sidebar" style={{ backgroundColor: this.props.domainColors.sidebarBackground }}
                >
                    <SideBar
                        color={this.props.domainColors} />
                </aside>
                <section className="main-preview__content">
                    <HeaderBar toggleSideBar={this.toggleSideBar} collapsed={this.state.collapsed} color={this.props.domainColors} />
                    <div className="ant-layout-divider">
                        <span className="divider-red"></span>
                        <span className="divider-blue"></span>
                        <span className="divider-yellow"></span>
                        <span className="divider-green"></span>
                    </div>
                    <div>
                        <img src="/images/sample_preview.png" width={700}/>
                    </div>
                </section>

            </div>
        );
    }
}

export default PreviewComponent;
